/* Shared cart mutations: one request at a time, explicit errors, no automatic add retry. */
(function (root) {
  'use strict';
  function createClient(fetcher, routes, notify) {
    var pending = false;
    async function request(url, options) {
      var controller = new AbortController(), timer = setTimeout(function () { controller.abort(); }, 20000);
      try {
        var response = await fetcher(url, Object.assign({ credentials: 'same-origin', cache: 'no-store' }, options || {}, { signal: controller.signal }));
        var body;
        try { body = await response.json(); } catch (e) { body = null; }
        if (!response.ok) {
          var message = body && (body.description || body.message);
          var error = new Error(typeof message === 'string' ? message : 'Shopify could not update your bag. Please check your selection and try again.');
          error.status = response.status; throw error;
        }
        if (!body) throw new Error('The response could not be confirmed. Please check your bag before trying again.');
        return body;
      } finally { clearTimeout(timer); }
    }
    function read() { return request(routes.cart, { headers: { Accept: 'application/json' } }); }
    async function mutate(url, payload) {
      if (pending) { var busy = new Error('Your bag is still updating. Please wait.'); busy.busy = true; throw busy; }
      pending = true; if (notify) notify(true);
      try {
        var isForm = typeof FormData !== 'undefined' && payload instanceof FormData;
        var headers = { Accept: 'application/json' };
        if (!isForm) headers['Content-Type'] = 'application/json';
        await request(url, { method: 'POST', headers: headers, body: isForm ? payload : JSON.stringify(payload) });
        return await read();
      } catch (error) {
        // Reading is safe after an uncertain POST. Repeating the POST is not.
        try { error.cart = await read(); } catch (ignored) {}
        if (!error.status) error.message = 'We could not confirm the update. Check your bag before trying again.';
        throw error;
      } finally { pending = false; if (notify) notify(false); }
    }
    return {
      read: read,
      isPending: function () { return pending; },
      add: function (payload) { return mutate(routes.add, payload); },
      change: function (id, quantity) {
        if (!id || !Number.isSafeInteger(quantity) || quantity < 0) return Promise.reject(new Error('Please enter a whole-number quantity of zero or more.'));
        return mutate(routes.change, { id: id, quantity: quantity });
      }
    };
  }
  // Klaviyo "Added to Cart" (email flow map #2): the item just added and the bag it landed in, in the property names
  // Klaviyo's cart-abandonment templates expect. Only identified visitors are recorded (Klaviyo's own rule).
  function addedToCartEvent(payload, cart, origin) {
    var get = function (k) { return payload && typeof payload.get === 'function' ? payload.get(k) : payload && (payload[k] != null ? payload[k] : payload.items && payload.items[0] && payload.items[0][k]); };
    var vid = Number(get('id')), qty = Number(get('quantity')) || 1, items = (cart && cart.items) || [];
    var it = items.filter(function (x) { return Number(x.variant_id) === vid || Number(x.id) === vid; })[0];
    if (!it) return null;
    var abs = function (u) { return !u ? '' : /^https?:/.test(u) ? u : /^\/\//.test(u) ? 'https:' + u : (origin || '') + u; };
    return {
      $value: cart.total_price / 100,
      AddedItemProductName: it.product_title, AddedItemProductID: String(it.product_id), AddedItemSKU: it.sku || '',
      AddedItemVariantName: it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '',
      AddedItemImageURL: abs(it.image), AddedItemURL: abs(it.url), AddedItemPrice: it.final_price / 100, AddedItemQuantity: qty,
      ItemNames: items.map(function (x) { return x.product_title; }),
      CheckoutURL: (origin || '') + '/checkout',
      Items: items.map(function (x) { return { ProductID: String(x.product_id), SKU: x.sku || '', ProductName: x.product_title, Quantity: x.quantity,
        ItemPrice: x.final_price / 100, RowTotal: x.final_line_price / 100, ProductURL: abs(x.url), ImageURL: abs(x.image) }; })
    };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createClient: createClient, addedToCartEvent: addedToCartEvent };
  if (!root || !root.document) return;
  var document = root.document, data = document.getElementById('rrStoreData');
  if (!data) return;
  var config = JSON.parse(data.textContent), drawer = document.getElementById('skCartDrawer'), scrim = document.getElementById('skCartScrim');
  if (!drawer || !scrim) return;
  var savedDisabled = new WeakMap(), lastCart = null, revision = 0;
  var errorEl = document.getElementById('rrCartError'), pageError = document.getElementById('rrCartPageError');
  function error(message) {
    [errorEl, pageError].forEach(function (el) { if (el) { el.textContent = message || ''; el.hidden = !message; } });
  }
  function setPending(pending) {
    if(pending) revision++;
    document.querySelectorAll('form[action*="/cart/add"] button[type="submit"],.sk-cd-step,.sk-cd-remove,.sk-ci-step,.sk-ci-remove,.sk-ci-qinput,.sk-wd-add[data-vid],#skCartForm button[name="checkout"]').forEach(function (b) {
      if (pending) { savedDisabled.set(b, b.disabled); b.disabled = true; }
      else if (savedDisabled.has(b)) {
        var nativeSelect = document.querySelector('#pdpForm select[name="id"]:not([disabled])');
        b.disabled = b.id === 'pdpAtc' ? (nativeSelect ? !nativeSelect.value : document.getElementById('pdpVariantId').disabled) : savedDisabled.get(b);
        savedDisabled.delete(b);
      }
    });
    drawer.setAttribute('aria-busy', pending ? 'true' : 'false');
    document.querySelectorAll('.sk-cd-checkout').forEach(function (a) { a.setAttribute('aria-disabled', pending ? 'true' : 'false'); });
  }
  var client = createClient(root.fetch.bind(root), config.routes, setPending);
  function money(cents) { return new Intl.NumberFormat(config.locale || 'en-US', { style: 'currency', currency: (lastCart && lastCart.currency) || config.currency || 'USD' }).format(cents / 100); }
  function esc(value) { return String(value == null ? '' : value).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function imgw(url, width) { if (!url) return ''; return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + width; }
  function render(cart) {
    lastCart = cart;
    document.getElementById('skCdN').textContent = cart.item_count;
    document.querySelectorAll('[data-cart-n]').forEach(function (b) { b.textContent = cart.item_count; b.hidden = !cart.item_count; });
    document.querySelectorAll('[data-cart-open].sk-bag').forEach(function (a) { a.setAttribute('aria-label', 'Bag (' + cart.item_count + ')'); });
    var empty = !cart.item_count, items = document.getElementById('skCdItems'), ship = document.getElementById('skCdShip');
    document.getElementById('skCdEmpty').hidden = !empty;
    document.getElementById('skCdFoot').hidden = empty;
    document.getElementById('skCdSub').textContent = money(cart.total_price);
    var threshold = Number(config.freeShippingThreshold), thresholdApplies = threshold > 0 && cart.requires_shipping && cart.currency === config.shippingCurrency;
    ship.hidden = empty || !thresholdApplies;
    if (thresholdApplies) {
      var remaining = Math.max(0, threshold - cart.total_price), percent = Math.min(100, Math.max(0, Math.round(cart.total_price / threshold * 100)));
      ship.innerHTML = '<div class="sk-cd-shiptxt">' + (remaining ? 'You’re <strong>' + esc(money(remaining)) + '</strong> away from free US shipping.' : 'You’ve unlocked <strong>free US shipping</strong>.') + '</div><div class="sk-cd-bar"><i style="width:' + percent + '%"></i></div>';
    }
    items.innerHTML = cart.items.map(function (it) {
      var image = imgw(it.image, 160), option = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="sk-cd-opt">' + esc(it.variant_title) + '</div>' : '';
      var was = it.original_price !== it.final_price ? ' <s>' + esc(money(it.original_price)) + '</s>' : '';
      return '<div class="sk-cd-item" data-key="' + esc(it.key) + '"><a class="sk-cd-media" href="' + esc(it.url) + '">' + (image ? '<img src="' + esc(image) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '') + '</a><div class="sk-cd-info"><a class="sk-cd-name" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + option + '<div class="sk-cd-price">' + esc(money(it.final_price)) + was + '</div><div class="sk-cd-row"><div class="sk-cd-qty"><button type="button" class="sk-cd-step" data-key="' + esc(it.key) + '" data-dir="-1" aria-label="Decrease quantity">−</button><span class="sk-cd-qn">' + it.quantity + '</span><button type="button" class="sk-cd-step" data-key="' + esc(it.key) + '" data-dir="1" aria-label="Increase quantity">+</button></div><button type="button" class="sk-cd-remove" data-key="' + esc(it.key) + '">Remove</button></div></div><div class="sk-cd-line">' + esc(money(it.final_line_price)) + '</div></div>';
    }).join('');
    document.dispatchEvent(new CustomEvent('rr:cart-updated', { detail: { itemCount: cart.item_count, total: cart.total_price, currency: cart.currency } }));
  }
  function openDrawer() {
    var nav = document.getElementById('skMnav'), navScrim = document.getElementById('skMnavScrim');
    if (nav) { nav.classList.remove('on'); nav.setAttribute('aria-hidden', 'true'); }
    if (navScrim) navScrim.classList.remove('on');
    drawer.classList.add('on'); scrim.classList.add('on'); drawer.setAttribute('aria-hidden', 'false'); document.body.style.overflow = 'hidden';
  }
  function close() { drawer.classList.remove('on'); scrim.classList.remove('on'); drawer.setAttribute('aria-hidden', 'true'); document.body.style.overflow = ''; }
  async function refresh() { var requestRevision = revision; var cart = await client.read(); if (requestRevision === revision && !client.isPending()) render(cart); return cart; }
  async function open() {
    error(''); openDrawer();
    try { return await refresh(); } catch (e) { error('Your bag could not load. Please try again or open the full bag.'); document.getElementById('skCdFoot').hidden = false; }
  }
  async function change(id, qty, fromPage) {
    error('');
    try {
      var cart = await client.change(id, qty); render(cart);
      if (fromPage) root.location.reload();
    } catch (e) { if (e.cart) render(e.cart); error(e.message); }
  }
  async function add(payload) {
    error('');
    try {
      var cart = await client.add(payload); render(cart); openDrawer();
      try { var ev = addedToCartEvent(payload, cart, root.location.origin); if (ev) { if (root.klaviyo && typeof root.klaviyo.track === 'function') root.klaviyo.track('Added to Cart', ev); else (root._learnq = root._learnq || []).push(['track', 'Added to Cart', ev]); } } catch (ignored) {}
      return cart;
    }
    catch (e) { if (e.cart) render(e.cart); if (!e.busy) openDrawer(); error(e.message); throw e; }
  }
  root.RRCart = { add: add, change: change, refresh: refresh, isPending: client.isPending };
  root.skCartOpen = open; root.skCartClose = close; root.skCartRefresh = refresh;
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    if (event.submitter && event.submitter.classList.contains('shopify-payment-button__button')) return;
    event.preventDefault();
    if (client.isPending()) return;
    if (!form.reportValidity()) return;
    add(new FormData(form)).catch(function () {});
  });
  document.addEventListener('click', function (event) {
    var target = event.target.closest('[data-cart-open],.sk-cd-step,.sk-cd-remove,.sk-ci-step,.sk-ci-remove,.sk-cd-checkout');
    if (!target) return;
    if (target.matches('.sk-cd-checkout')) { if (client.isPending()) event.preventDefault(); return; }
    event.preventDefault();
    if (target.hasAttribute('data-cart-open')) { open(); return; }
    if (client.isPending()) return;
    var page = target.matches('.sk-ci-step,.sk-ci-remove'), key = target.dataset.key;
    var quantity = 0;
    if (target.matches('.sk-cd-step,.sk-ci-step')) {
      var item = lastCart && lastCart.items.find(function (it) { return it.key === key; });
      var input = target.parentNode.querySelector('.sk-ci-qinput');
      quantity = Math.max(0, (item ? item.quantity : Number(input && input.value)) + Number(target.dataset.dir));
    }
    change(key, quantity, page);
  });
  document.addEventListener('change', function (event) {
    var input = event.target.closest('.sk-ci-qinput');
    if (input && !client.isPending()) change(input.dataset.key, Number(input.value), true);
  });
  document.getElementById('skCdX').addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (event) { if (event.key === 'Escape' && drawer.classList.contains('on')) close(); });
  refresh().catch(function () {});
})(typeof window === 'undefined' ? null : window);
